function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DocumentCardDetails, DocumentCardPreview, DocumentCardTitle, DocumentCardType, getTheme, IconButton, Layer, Stack, Text } from 'office-ui-fabric-react';
import React, { useEffect } from 'react';
import { ToastType } from '../Toast';
import { DocumentCard } from '../DocumentCard';
import { ActionIconName, SemanticIconName } from '../Icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ToastLayer = _ref => {
  let {
    forceRenderMessagesOnTopLayer,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Layer, {
    styles: {
      root: {
        padding: 40,
        display: 'flex',
        justifyContent: 'flex-end',
        height: 'fit-content',
        zIndex: forceRenderMessagesOnTopLayer ? Number.MAX_SAFE_INTEGER : undefined
      }
    },
    children: children
  });
};
export const ToastLayerToast = props => {
  useEffect(() => {
    if (!props.isOpen) return;
    const timer = setTimeout(() => {
      props.onClose();
    }, props.visibilityTime);
    return () => clearTimeout(timer);
  }, []);
  const getIconColor = () => {
    switch (props.type) {
      case ToastType.Info:
        return getTheme().palette.yellowDark;
      case ToastType.Success:
        return getTheme().palette.greenDark;
      case ToastType.Warning:
        return getTheme().palette.red;
    }
  };
  const getIconType = () => {
    switch (props.type) {
      case ToastType.Info:
        return SemanticIconName.Info;
      case ToastType.Success:
        return SemanticIconName.Yes;
      case ToastType.Warning:
        return SemanticIconName.Alert;
    }
  };
  const getDocumentCardPreviewProps = () => ({
    previewImages: [{
      previewIconProps: {
        iconName: getIconType(),
        styles: {
          root: {
            fontSize: getTheme().fonts.large.fontSize,
            color: getIconColor()
          }
        }
      }
    }],
    styles: {
      previewIcon: {
        backgroundColor: getTheme().palette.white
      },
      root: {
        borderRight: 'none !important'
      }
    }
  });
  const renderCloseIcon = () => /*#__PURE__*/_jsx(IconButton, {
    iconProps: {
      iconName: ActionIconName.Close,
      styles: {
        root: {
          color: getTheme().palette.neutralDark
        }
      }
    },
    styles: {
      root: {
        padding: 16,
        marginLeft: 'auto !important'
      }
    },
    onClick: props.onClose,
    size: 16
  });
  return /*#__PURE__*/_jsx(DocumentCard, {
    type: DocumentCardType.compact,
    "data-id": props.dataId,
    styles: {
      root: {
        width: 500,
        height: 'auto',
        boxShadow: 'rgba(0, 0, 0, 0.22) 0px 25.6px 57.6px 0px, rgba(0, 0, 0, 0.18) 0px 4.8px 14.4px 0px',
        '&:not(:first-of-type)': {
          marginTop: 20
        },
        padding: 16
      }
    },
    children: /*#__PURE__*/_jsxs(DocumentCardDetails, {
      children: [/*#__PURE__*/_jsxs(Stack, {
        horizontal: true,
        verticalAlign: "center",
        tokens: {
          childrenGap: 16
        },
        children: [/*#__PURE__*/_jsx(DocumentCardPreview, _objectSpread({}, getDocumentCardPreviewProps())), /*#__PURE__*/_jsx(DocumentCardTitle, {
          styles: {
            root: {
              height: 'auto',
              padding: 0,
              fontWeight: 600,
              '&.ms-DocumentCardTitle': {
                fontSize: 20,
                lineHeight: 'unset'
              }
            }
          },
          title: props.title,
          "data-id": "".concat(props.dataId, "-title")
        }), renderCloseIcon()]
      }), /*#__PURE__*/_jsx(Text, {
        styles: {
          root: {
            color: getTheme().palette.neutralSecondaryAlt,
            marginTop: 5
          }
        },
        "data-id": "".concat(props.dataId, "-description"),
        children: props.subText
      })]
    })
  });
};